import { DocumentsImagesPanelThumbnails } from '@shared/documents-images/ui/DocumentsImagesPanelThumbnails';
import { Events } from '@shared/Events';
import { ImagesService } from '@shared/images/ImagesService';
import { TreeNode } from '@shared/ui-native/Tree';
import { Button } from '@shared/ui-react/Button';
import { ImagePanoViewer, ImageViewerInfo } from '@shared/ui-react/ImagePanoViewer';
import { cs } from '@shared/utils/utils-classname';
import * as React from 'react';
import { DocumentPropertiesList } from './DocumentPropertiesList';
import './ImageViewerWithNavigation.scss';

export class ImageViewerWithNavigation extends React.Component<
    {
        initialId: number;
        queue: IImage[];
        onEdit?: (item: IImage) => void;
        onCenter: (item: IImage) => void;
        onClose?: () => void;
        onOpenFolderId: (folderId: number, imageId: number) => void;
        getFolderTreeNode: (folderId: number) => TreeNode;
        isImageCluster?: boolean;
        isMobile?: boolean;
        getAllPanoramas: () => IImage[];
        onChange?: (image: IImage) => void;
    },
    {
        currentIndex: number;
        showQueueThumbnails?: boolean;
    }
> {
    viewer: any = null;

    state = {
        currentIndex: this.props.initialId ? this.props.queue.findIndex(i => i.id === this.props.initialId) : 0,
        showQueueThumbnails: false,
    };

    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        Events.trigger('map-highlight-clear');
    }

    goNext = () =>
        this.setState(
            prevState => ({
                currentIndex: (prevState.currentIndex + 1) % this.props.queue.length,
                showQueueThumbnails: false,
            }),
            this.triggerOnChange
        );

    goPrev = () =>
        this.setState(
            prevState => ({
                currentIndex: (prevState.currentIndex - 1 + this.props.queue.length) % this.props.queue.length,
                showQueueThumbnails: false,
            }),
            this.triggerOnChange
        );

    goFirst = () => this.setState({ currentIndex: 0, showQueueThumbnails: false }, this.triggerOnChange);

    goLast = () => this.setState({ currentIndex: this.props.queue.length - 1, showQueueThumbnails: false }, this.triggerOnChange);

    setIndexByImageId = (imageId: number) => {
        const index = this.props.queue.findIndex(i => i.id === imageId);
        this.setState({ currentIndex: index, showQueueThumbnails: false }, this.triggerOnChange);
    };

    toggleQueueThumbnails = () => {
        this.setState({ showQueueThumbnails: !this.state.showQueueThumbnails });
    };

    triggerOnChange = () => {
        if (this.props.onChange) {
            this.props.onChange(this.props.queue[this.state.currentIndex]);
        }
    };

    render() {
        const { queue, isImageCluster, isMobile, onEdit, onClose } = this.props;
        if (!queue.length) {
            return <div>Cant find the image</div>;
        }

        const index = this.state.currentIndex;
        const image = queue[index];
        const total = queue.length;
        const hasLocation = image.geographicPoint?.lon && image.geographicPoint?.lon !== 0;
        const canEdit = !!onEdit && kuura.hasPrivilege('IMAGE_PAGE') && !isMobile;
        const canDownload = kuura.hasPrivilege('Download_Image');

        let parents = [];
        const folderNode = this.props.getFolderTreeNode(image.folderId);
        if (folderNode) {
            parents = folderNode.getParents();
            parents.push(folderNode);
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', flexGrow: 1 }}>
                <nav id='image-popup-controls' className={cs('floating-window-toolbar', { reversed: isMobile })}>
                    <div className='flex-row ai-center prev-next-counts'>
                        {total > 1 && (
                            <>
                                <div id='image-popup-prev' className='toolbar-btn' style={{ paddingLeft: '1em', paddingRight: '1em' }} onClick={this.goPrev}>
                                    <i className='iki iki-chevron-left'></i>
                                </div>
                                <div id='image-popup-next' className='toolbar-btn' style={{ paddingLeft: '1em', paddingRight: '1em' }} onClick={this.goNext}>
                                    <i className='iki iki-chevron-right'></i>
                                </div>
                            </>
                        )}
                        <div className='toolbar-btn image-popup-counts flex-row' onClick={this.toggleQueueThumbnails}>
                            <div className='flex-row' style={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                <span className='flex-row ai-center'>{index + 1} /</span>
                                <span className='flex-row ai-center'>&nbsp;{total}</span>
                            </div>
                            {isImageCluster && <i style={{ marginLeft: 10 }} className='iki iki-grid' title='Showing images at selected location, cluster  or folder' />}
                        </div>
                    </div>

                    <div className='flex-row'>
                        {canEdit ? (
                            <Button
                                element='div'
                                tooltip={__('general.edit')}
                                icon='iki iki-edit'
                                className='toolbar-btn'
                                id='image-popup-edit'
                                onClick={() => this.props.onEdit(image)}
                            />
                        ) : null}
                        {hasLocation ? (
                            <Button
                                element='div'
                                tooltip={__('general.locate_on_map')}
                                icon='iki iki-map-pin'
                                className='toolbar-btn'
                                id='image-popup-center'
                                onClick={() => this.props.onCenter(image)}
                            />
                        ) : null}
                        {canDownload && (
                            <Button
                                element='div'
                                tooltip={__('general.download')}
                                icon='iki iki-download'
                                className='toolbar-btn'
                                onClick={() => ImagesService.download([image.id], image.name)}
                            />
                        )}
                        <Button
                            element='div'
                            tooltip={__('js_images.open_full_in_new_tab')}
                            icon='iki iki-external'
                            className='toolbar-btn'
                            id='image-popup-expand'
                            onClick={() => this.viewer.toggleFullscreen()}
                        />
                        {!!onClose && (
                            <div className='toolbar-btn' id='image-popup-close' onClick={onClose}>
                                <i className='iki iki-cross' />
                            </div>
                        )}
                        {isMobile && (
                            <div className='toolbar-btn' onClick={() => this.props.onOpenFolderId(parents[parents.length - 1].id, image.id)}>
                                <i className='iki iki-folder-open' />
                            </div>
                        )}
                    </div>
                </nav>

                {this.state.showQueueThumbnails && (
                    <div className='flex-column of-h'>
                        <DocumentsImagesPanelThumbnails
                            type='images'
                            items={queue}
                            unfilteredItems={queue}
                            canEdit={false}
                            canSelect={false}
                            canDownload={false}
                            focusItemId={image.id}
                            onClick={this.setIndexByImageId}
                        />
                    </div>
                )}

                <div
                    id='image-popup-wrapper'
                    className={image.panorama ? 'panorama' : null}
                    style={{
                        overflow: this.props.isMobile ? 'auto' : 'hidden',
                        display: !this.state.showQueueThumbnails ? 'flex' : 'none',
                    }}
                >
                    <ImagePanoViewer
                        showInfo={false}
                        image={image}
                        isMobile={isMobile}
                        getAllPanoramas={this.props.getAllPanoramas}
                        openImageId={this.setIndexByImageId}
                        ref={instance => (this.viewer = instance)}
                    />

                    <div
                        className='flex-column'
                        style={{
                            overflow: this.props.isMobile ? 'hidden' : 'auto',
                            flexGrow: 0,
                            maxHeight: this.props.isMobile ? 'initial' : 300,
                            minHeight: 50,
                            flexShrink: this.props.isMobile ? 0 : 1,
                        }}
                    >
                        <ImageViewerInfo image={image} position='bottom'>
                            <div style={{ textAlign: 'left' }}>
                                <span>{kuura.getMessage('general.folder')}: </span>
                                <span>
                                    {parents.map((p, i) => (
                                        <span key={p.id} className='image-popup-folder clickable' onClick={() => this.props.onOpenFolderId(p.id, image.id)}>
                                            {p.ajaxData.name} {i < parents.length - 1 ? ' > ' : null}
                                        </span>
                                    ))}
                                </span>
                            </div>
                        </ImageViewerInfo>

                        <div style={{ textAlign: 'left', margin: '0 0 5px 20px' }}>
                            <DocumentPropertiesList doc={image} canEdit={canEdit} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
